/*
 * Generated from MrCap.BL.Init
 */

export interface BookingFormSettings {
  text: BookingFormTexts;
  ecsterConfig: EcsterConfig;
  weightThreshold: number;
  initialFilterArticleGroup: string;
  mabi: MabiBooking | null;
}

export interface BookingFormTexts {
  stepZeroHeader: string;
  stepZeroParagraph: string;
  stepOneHeader: string;
  stepOneParagraph: string;
  stepOneFormHeader: string;
  stepOneFormDesc: string;
  stepOneNoProducts: string;
  stepOneCallHeader: string;
  stepOneCallParagraph: string;
  stepOneOtherServicesHeader: string;
  stepOneOtherServicesContent: string;
  stepTwoHeader: string;
  stepTwoParagraph: string;
  stepTwoRentalHeader: string;
  stepTwoRentalDesc: string;
  stepTwoRentalMessage: string;
  stepTwoShopChangedMessage: string;
  stepThreeHeader: string;
  stepThreeParagraph: string;
  stepThreePaymentOnSite: string;
  stepThreeGdpr: string;
  stepThreeNewsletter: string;
  stepThreeSummaryMessage: string;
  stepFourHeader: string;
  stepFourParagraph: string;
}

export interface EcsterConfig {
  script: string;
  termsUrl: string;
}

export interface MabiBooking {
  stations: RentalStation[];
  vehicles: RentalVehicle[];
}

export interface RentalStation {
  misterStation: number;
  name: string;
  address: string;
  phone: string;
}

export interface RentalVehicle {
  artNr: string;
  name: string;
  sortOrder: number;
  price: number;
}

export interface BookingRequest {
  name: string;
  address: string;
  city: string;
  zipCode: string;
  comment: string;
  phone: string;
  email: string;
  bookingType: BookingType;
  stationId: number;
  regNr: string;
  bookingDate: Date;
  newsletter: boolean;
  articles: ArticleInfo[];
  campaingId: string;
  consent?: boolean;
  mabiVehicle: string;
  driversLicenseNumber: string;
  rentalConsent?: boolean;
}

export enum BookingType {
  ecsterPay = 0,
  onLocation = 1
}

export interface ArticleInfo {
  artNr: string;
  noi: number;
}

export interface BookingResponse {
  ok: boolean;
  error?: string;
  orderId: string;
  shipping: number;
}

export interface Product {
  articleNr: string;
  priceBase: number;
  priceNew: number;
  priceVehicle: number;
  salePriceVehicle?: number;
  discount?: number;
  title: string;
  descShort: string;
  descLong: string;
  productImgUrl: string;
  type: ArticleType;
  group: string | null;
  pickUpDayAfter: boolean;
  noi: number;
  upsellArticleNr: string;
  downsellArticleNr: string;
}

export enum ArticleType {
  standard = 0,
  treatment = 1,
  product = 2
}

export interface CallData {
  name: string;
  phone: string;
  shopName: string;
  shopEmail: string;
  message: string;
}

export interface ProductsResponse {
  products: Product[];
  campaign: CampaignResponse;
}

export interface CampaignResponse {
  code: string;
  name: string;
  discount: number;
  paymentTypes: string;
}

export interface Shop {
  id: number;
  name: string;
  address: string;
  city: string;
  phone: string;
  email: string;
  lat?: number;
  lng?: number;
  slug: string;
}

export interface OrderInfo {
  id: number;
  firstName: string;
  lastName: string;
  address: string;
  zipCode: string;
  city: string;
  email: string;
  phone: string;
  regNr: string;
  stationId: number;
  stationName: string;
  bookingDate: Date;
  paymentReference: string;
  paymentProvider: string;
  endPrice: number;
  endVatPrice: number;
  shipping: number;
}

export interface VehicleInfo {
  brand: string;
  model: string;
  color: string;
  registrationDate: Date;
  weight: number;
}

